import { Home } from 'modules/home';

export default Home;
